import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unarchivePatient } from '../api/patients'

export function useUnarchivePatient() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: unarchivePatient,
    onSuccess: (updatedPatient) => {
      // Update the individual patient cache
      queryClient.setQueryData(['patient', updatedPatient.id], updatedPatient)
      // Invalidate the patients list
      queryClient.invalidateQueries({ queryKey: ['patients'] })
    },
  })
}
